import { observable } from 'mobx';

import { SerializedData, Store } from 'bernie-core';

export class GaiaIdStore extends Store {
  @observable public gaiaId?: string | null;

  public hydrate(data: SerializedData): void {
    Object.assign(this, data);
  }
}
